import { Card } from 'antd';
import styled from 'styled-components';

export const AttachmentThumbAnchor = styled.a`
  text-align: center;
  color: inherit;
  &:hover {
    color: inherit;
  }
`;

export const AttachmentNameRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
`;

export const AttachmentName = styled.span`
  flex: 1;
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const AttachmentCard = styled(Card)<{ $isChildTaskAttachment: boolean }>`
  height: 100%;
  display: flex;
  flex-direction: column;

  ${({ theme, $isChildTaskAttachment }) => {
    return `
      .ant-card-cover {
        display: flex;
        align-items: center;
        min-height: 200px;
        cursor: pointer;
        ${$isChildTaskAttachment ? `background-color: ${theme.borderColor};` : ''}
      }

      .ant-card-body {
        flex: 1;
        ${$isChildTaskAttachment ? `background-color: ${theme.borderColor};` : ''}
      }

      .ant-card-actions {
        margin-top: auto;
      }

      .ant-card-meta-title {
        white-space: normal;
        overflow: visible;
        text-overflow: unset;
      }
    `;
  }}
`;
